import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSpecificRowSubTask = createAsyncThunk(
  "SubTaskReducer/GetSpecificRowSubTask",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SubTasks/GetSpecificRowSubTask",
        parameters
      );

      const data = response.data.result; 

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const ChangeStatusSubTasks = createAsyncThunk(
    "SubTaskReducer/ChangeStatusSubTasks",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SubTasks/ChangeStatusSubTasks",
          parameters
        );
  
        const data = response.data.result; 
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const CloseTasksCcompleteInitialAssessment = createAsyncThunk(
    "SubTaskReducer/CloseTasksCcompleteInitialAssessment",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SubTasks/CloseTasksCcompleteInitialAssessment",
          parameters
        );
  
        const data = response.data.result; 
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const SubTaskReducer = createSlice({
  name: "FlowActionByTaskId",
  initialState: {
    SubTaskRow: [],
    loadingSubTaskRow: false,
    errorSubTaskRow: null,
    //////////////////////////////////////
    ChangeStatusResult: [],
    loadingChangeStatusResult: false,
    errorChangeStatusResult: null,
    //////////////////////////////////////
    CloseTasksCcompleteInitialAssessmentResult: [],
    loadingCloseTasksCcompleteInitialAssessmentResult: false,
    errorCloseTasksCcompleteInitialAssessmentResult: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetSpecificRowSubTask.pending, (state, action) => {
        state.loadingSubTaskRow = true;
        state.SubTaskRow = action.payload;
        state.errorSubTaskRow = null;
      })
      .addCase(GetSpecificRowSubTask.fulfilled, (state, action) => {
        state.loadingSubTaskRow = false;
        state.SubTaskRow = action.payload;
      })
      .addCase(GetSpecificRowSubTask.rejected, (state, action) => {
        state.loadingSubTaskRow = false;
        state.SubTaskRow = action.payload;
      });


      builder
      .addCase(ChangeStatusSubTasks.pending, (state, action) => {
        state.loadingChangeStatusResult = true;
        state.ChangeStatusResult = action.payload;
        state.errorChangeStatusResult = null;
      })
      .addCase(ChangeStatusSubTasks.fulfilled, (state, action) => {
        state.loadingChangeStatusResult = false;
        state.ChangeStatusResult = action.payload;
      })
      .addCase(ChangeStatusSubTasks.rejected, (state, action) => {
        state.loadingChangeStatusResult = false;
        state.ChangeStatusResult = action.payload;
      });
      builder
      .addCase(CloseTasksCcompleteInitialAssessment.pending, (state, action) => {
        state.loadingCloseTasksCcompleteInitialAssessmentResult = true;
        state.CloseTasksCcompleteInitialAssessmentResult = action.payload;
        state.errorCloseTasksCcompleteInitialAssessmentResult = null;
      })
      .addCase(CloseTasksCcompleteInitialAssessment.fulfilled, (state, action) => {
        state.loadingCloseTasksCcompleteInitialAssessmentResult = false;
        state.CloseTasksCcompleteInitialAssessmentResult = action.payload;
      })
      .addCase(CloseTasksCcompleteInitialAssessment.rejected, (state, action) => {
        state.loadingCloseTasksCcompleteInitialAssessmentResult = false;
        state.CloseTasksCcompleteInitialAssessmentResult = action.payload;
      });
  },
});

export default SubTaskReducer.reducer;
